export const siteEmojiWtf: {
    category: string; creatorUserId: string; fallback: string; id: string; name: string; order: number; representation: {
        height: number;
        imagePath: string;
        width: number;
    }; searchable: boolean; shortName: string; skinVariations: never[]; type: string;
} = {
	id: 'wtf',
	name: 'wtf',
	fallback: ':wtf:',
	type: 'SITE',
	category: 'CUSTOM',
	order: -1000,
	searchable: true,
	shortName: ':wtf:',
	creatorUserId: 'Thor',
	representation: {
		height: 120,
		width: 100,
		imagePath:
			'https://pf-emoji-service--cdn.ap-southeast-2.dev.public.atl-paas.net/atlassian/wtf@4x.png',
	},
	skinVariations: [],
};
